import React, { useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { updateUser } from '@/actions/user';
import useUser from '@/hooks/useUser';
import FavoriteMenuListItem from '@/components/favorites/FavoriteMenuListItem';
import { favoritePost } from '@/domains/firestore/user';
import { IMenu } from '@/@types/generated/contentful';

type ComponentProps = {
  menu: IMenu;
};

const FavoriteMenuListItemContainer: React.FC<ComponentProps> = ({ menu }) => {
  const [isLoading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const user = useUser();
  const handleRequestUpdateFavorite = useCallback(
    async (postId: string) => {
      setLoading(true);
      try {
        if (user) {
          await favoritePost({ userId: user.uid, postId });
          await dispatch(updateUser(user.uid));
        }
      } catch {
        // noop
      } finally {
        setLoading(false);
      }
    },
    [dispatch, user]
  );

  return (
    <FavoriteMenuListItem
      menu={menu}
      onRequestUpdateFavorite={handleRequestUpdateFavorite}
      invalid={isLoading}
    />
  );
};

export default FavoriteMenuListItemContainer;
